import { Observer } from "rxjs/internal/types";
import { Subscription } from "rxjs";

export interface ITableContextValue {
  subscribe: (observer: Observer<ITableState>) => Subscription;
  subscribeAction: (observer: Observer<IAction>) => Subscription;
  dispatch: (action: IAction) => void;
  resetTable: () => void;
}

export type TFilter = {
  id: string;
  value: any;
  compare: (
    filterValue: any,
    cellValue: any,
    parse?: (value: any) => string
  ) => boolean;
};

export type TColumnSorting = {
  active: boolean;
  direction: "asc" | "desc";
};

export type TSortDirection = "asc" | "desc" | false;

export interface ISorting {
  sortDirection: TSortDirection;
  id: string;
}

export interface ITableState {
  filters: TFilter[];
  sorting: ISorting | undefined;
  searchInput: string;
  columns: IColumn[];
  page: number;
  rowsPerPage: number;
  rawData: any[];
  filterData: any[];
  loading: boolean;
  id?: string;
}

export enum TableActionTypes {
  onFilter = "@@ON_FILTER",
  execFilter = "@@EXEC_FILTER",
  cleanFilter = "@@CLEANC_FILTER",
  sorting = "@@SORTING",
  reset = "@@RESET",
  init = "@@INIT",
  onChangePage = "@@ON_CHANGE_PAGE",
  onChangeRowsPerPage = "@@ON_CHANGE_ROWS_PER_PAGE",
  onRowClick = "@@ON_ROW_CLICK",
  search = "@@SEARCH",
  onSearch = "@@ON_SEARCH"
}

export interface IAction {
  type: TableActionTypes;
  name?: string;
  meta?: any;
  payload?: any;
}

export type TColumnType = "date" | "empty" | "text" | "number";

export type TFilterWidget = (
  filterValue: any,
  onFilterChange: (payload: {
    value: any;
    compare: (filterValue: any, cellValue: any) => boolean;
  }) => void,
  meta: any
) => JSX.Element;

export interface IColumn {
  label: string;
  id: string;
  renderCell?: (cell: any, row: any) => any;
  searchable?: boolean;
  filterWidget?: TFilterWidget;
  type?: TColumnType;
  parse?: (cell: any) => string;
  meta?: any;
  hide?: boolean;
}

export interface ITable<Row> {
  rowsPerPage: number;
  data: Row[];
  columns: IColumn[];
  getRowId: (row: Row) => string;
  sorting?: ISorting;
  tableRowProps?: (row: Row) => Dictionary<any>;
  onRowClick?: (row: Row) => void;
  loading?: boolean;
  id?: string;
}

export interface Dictionary<T> {
  [Key: string]: T;
}
